export function extractLocationNumericId(gid) {
  if (gid == null) return null;
  const match = String(gid).match(/Location\/(\d+)/);
  return match ? Number(match[1]) : Number(gid) || null;
}

export function toLocationGid(numericId) {
  return `gid://shopify/Location/${numericId}`;
}

export function variantIdToGid(variantId) {
  return `gid://shopify/ProductVariant/${variantId}`;
}

export function parseGettingYourOrderData(container) {
  const dataScript = container?.querySelector('.js-getting-your-order-data');
  if (!dataScript?.textContent) return null;

  try {
    return JSON.parse(dataScript.textContent);
  } catch {
    return null;
  }
}

export function buildStoreAvailabilityMap(storeAvailabilities = []) {
  return new Map(
    storeAvailabilities.map((entry) => [entry.locationId, entry])
  );
}

export function getAvailabilityAtLocation(storeAvailabilityMap, locationGidOrNumeric) {
  const numericId = extractLocationNumericId(locationGidOrNumeric);
  if (numericId == null) return null;
  return storeAvailabilityMap.get(numericId) ?? null;
}

export function isPickupAvailableAtLocation(storeAvailabilityMap, locationGidOrNumeric) {
  return getStoreQuantityAtLocation(storeAvailabilityMap, locationGidOrNumeric) > 0;
}

export function hasInStoreOnlyTag(tags = []) {
  return tags.some((tag) => {
    const normalized = String(tag).trim().toLowerCase().replace(/-/g, ' ');
    return normalized === 'in store only';
  });
}

export function isPharmacistOnlyProduct(productType = '') {
  return String(productType).trim().toLowerCase() === '_pharmacist-only';
}

export function getAvailabilityStatus(quantity) {
  const stockOnHand = Number(quantity) || 0;

  if (stockOnHand >= 2) return 'in_stock';
  if (stockOnHand === 1) return 'low_stock';
  return 'unavailable';
}

export function isStandardDeliveryEligible(onlineQuantity, tags = []) {
  if (hasInStoreOnlyTag(tags)) return false;
  return (Number(onlineQuantity) || 0) > 0;
}

export function isStoreFulfilmentEligible(storeQuantity, tags = []) {
  if (hasInStoreOnlyTag(tags)) return false;
  return (Number(storeQuantity) || 0) > 0;
}

export function isInStoreEligible(storeQuantity) {
  return (Number(storeQuantity) || 0) > 0;
}

export function getStoreQuantityAtLocation(storeAvailabilityMap, locationGidOrNumeric) {
  const entry = getAvailabilityAtLocation(storeAvailabilityMap, locationGidOrNumeric);
  if (!entry) return 0;

  if (entry.quantityAvailable != null) {
    return Number(entry.quantityAvailable) || 0;
  }

  return 0;
}

export function mergeVariantAvailabilityData(baseVariantData, apiAvailability) {
  if (!baseVariantData) return null;

  const storeAvailabilityByLocationId = new Map(
    (baseVariantData.storeAvailabilities ?? []).map((entry) => [entry.locationId, { ...entry }])
  );

  (apiAvailability?.storeAvailabilities ?? []).forEach((entry) => {
    const existing = storeAvailabilityByLocationId.get(entry.locationId) ?? { locationId: entry.locationId };
    storeAvailabilityByLocationId.set(entry.locationId, {
      ...existing,
      quantityAvailable: entry.quantityAvailable,
      pickUpTime: entry.pickUpTime ?? existing.pickUpTime,
    });
  });

  return {
    ...baseVariantData,
    onlineQuantity:
      apiAvailability?.onlineQuantity == null
        ? null
        : Number(apiAvailability.onlineQuantity) || 0,
    storeAvailabilities: [...storeAvailabilityByLocationId.values()],
  };
}
